/**
 * @description 系统运行质量 systemWorkingQuality
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const systemWorkingQualityBiz = new Logic()

systemWorkingQualityBiz.systemAccident = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemWorkingQuality.systemAccident,
    data: data
  })
}

systemWorkingQualityBiz.systemVersion = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemWorkingQuality.systemVersion,
    data: data
  })
}

systemWorkingQualityBiz.accidentWeekStatistics = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemWorkingQuality.accidentWeekStatistics,
    data: data
  })
}

systemWorkingQualityBiz.versionWeekStatistics = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemWorkingQuality.versionWeekStatistics,
    data: data
  })
}

export default systemWorkingQualityBiz
